"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RoleHelper = require("./RoleHelper");
Object.keys(_RoleHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RoleHelper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RoleHelper[key];
    }
  });
});